// extracted by css-extract-rspack-plugin
export default {"headerBar":"headerBar-Xw3rC4","headerContent":"headerContent-ZbG0eg","tableBody":"tableBody-YUqNhu","tableArea":"tableArea-kBnpci"};